import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-beyond',
  templateUrl: './beyond.component.html',
  styleUrls: ['./beyond.component.scss']
})
export class BeyondComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
